import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Field, Formik} from "formik";
import * as Yup from 'yup'
import TextField from "../../../components/Ui/TextField";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import axios from "axios";
import {FIND_FICHE_BY_CODE, GET_FETCH_CODE} from "../../../api/Api";
import {useHistory} from 'react-router-dom'
import {toast} from "react-toastify";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1, 1)
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(5, 12)
        },
        [theme.breakpoints.up('lg')]: {
            padding: theme.spacing(10, 20)
        },
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    title: {
        marginBottom: 100
    }
}));

export default function(props){

    const classes = useStyles();
    const history = useHistory();

    const [isLoadingDetails,setIsLoadingDetails] = React.useState();


    async function loadDetails(email,code){

        try{

            setIsLoadingDetails(true);

            const response = await axios.get(
                `${GET_FETCH_CODE}`,
                {
                    params: {
                        email,
                        code
                    }
                }
            );

            history.push(`/fiches/details/${response.data}`)

        } catch (e) {

            if(e.response && e.response.status === 404)
                toast.error('Aucune demande correspondante trouver', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });  
        


        } finally {
            setIsLoadingDetails(false);
        }

    }

    return (

        <div className={`${classes.root} bg-white`}>

            <div className={`${classes.title} mb-5 font-weight-bolder h2`}>
                Recherche votre demande
            </div>

            <div className={''}>

                <Formik
                    initialValues={{
                        email: '',
                        code: ''
                    }}
                    validationSchema={Yup.object().shape({
                        email: Yup.string().required('Champ obligatoire'),
                        code: Yup.string().required('Champ obligatoire'),
                    })}
                    onSubmit={(values,formikHelpers)=>{

                        formikHelpers.setSubmitting(false);
                        loadDetails(values.email,values.code)

                    }}
                >

                    {
                        (formikHelpers) => {

                            return (

                                <div>

                                    <Field
                                        disabled={isLoadingDetails}
                                        name={'email'}
                                        component={TextField}
                                        label={'Adresse email utilié'}
                                    />

                                    <Field
                                        disabled={isLoadingDetails}
                                        name={'code'}
                                        label={'Code de votre demande'}
                                        component={TextField}
                                    />

                                    <BootstrapLoadingButton onClick={formikHelpers.submitForm} className={'btn btn-light-primary mt-5 d-block w-100'} isLoading={isLoadingDetails}>
                                        Rechercher votre demande
                                    </BootstrapLoadingButton>

                                </div>

                            )

                        }
                    }


                </Formik>

            </div>

        </div>
    );
}